import { apps } from './apps';
import { fct } from './fct';
import { hi } from './hi';
import { pii } from './pii';

export const api = { apps, fct, hi, pii };
